import { render, staticRenderFns } from "./SwitchCompany.vue?vue&type=template&id=db67a580&scoped=true"
import script from "./SwitchCompany.vue?vue&type=script&lang=js"
export * from "./SwitchCompany.vue?vue&type=script&lang=js"
import style0 from "./SwitchCompany.vue?vue&type=style&index=0&id=db67a580&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db67a580",
  null
  
)

export default component.exports